import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DeliveryItemsTableComponent } from '../delivery-items-table/delivery-items-table.component';
import { PaymentSummaryBlockComponent } from '../payment-summary-block/payment-summary-block.component';
import { Order } from '../../../graphql/generated/generated-types';

@Component({
  selector: 'app-sidenav-cart-inner',
  standalone: true,
  imports: [PaymentSummaryBlockComponent, DeliveryItemsTableComponent],
  templateUrl: './sidenav-cart-inner.component.html',
  styleUrl: './sidenav-cart-inner.component.scss'
})
export class SidenavCartInnerComponent {

  @Input() order: Order;
  


}
